// gp树高亮部分
export const INSTALL_KEY = 'install';
// gp树高亮部分
export const TREE_ID_KEY = 'treeId';
// gp树高亮部分
export const GPNO_KEY = 'GpNo';
// 树的层级
export const TREE_LEVEL_KEY = 'treelevel';

export const PATH_NAME = 'pathName';

//父节点
export const PARENT_NODES = 'parentNodes'

//
export const Path = 'Path'